import { useEffect, useState, useMemo } from 'react';
import getCenter from '@turf/center';
import bboxPolygon from '@turf/bbox-polygon';

export function useMapProperties(map) {
  const [extent, setExtent] = useState();
  const [size, setSize] = useState();
  const [zoom, setZoom] = useState(4);
  const [center, setCenter] = useState();

  useEffect(syncExtent, [map]);
  useEffect(syncSize, [map]);
  useEffect(syncCenter, [extent]);

  function syncExtent() {
    if (!map) return;

    function syncIt() {
      if (!map?.getBounds()) return;
      const sw = map.getBounds().getSouthWest();
      const ne = map.getBounds().getNorthEast();
      setExtent([sw.lng(), sw.lat(), ne.lng(), ne.lat()]);
      setZoom(map.getZoom());
    }

    syncIt();

    const listener = addListener(map, 'bounds_changed', syncIt);
    return () => listener.remove();
  }

  function syncSize() {
    if (!map) return;

    function syncIt() {
      setSize([map.getDiv()?.offsetWidth, map.getDiv()?.offsetHeight]);
    }

    syncIt();

    const listener = addListener(map, 'bounds_changed', syncIt);
    return () => listener.remove();
  }

  function syncCenter() {
    if (!extent) return;
    const [lng, lat] = getCenter(bboxPolygon(extent)).geometry.coordinates;
    setCenter({ lat, lng });
  }

  return useMemo(
    () => ({ size, extent, zoom, center }),
    [size, extent, zoom, center],
  );
}

function addListener(...params) {
  return window.google.maps.event.addListener(...params);
}
